import StockPaidPage from './StockPaidPage';
 
 export default StockPaidPage;